// Transform ability tiers. `index` is what the API stores (mx_transforms_skills.tier);
// `key` is what the import/export JSON uses as the grouping key.
export const TIERS = [
    { key: 'static',      label: 'Static',      index: 0 },
    { key: 'basic',       label: 'Basic',       index: 1 },
    { key: 'advanced',    label: 'Advanced',    index: 2 },
    { key: 'expert',      label: 'Expert',      index: 3 },
    { key: 'master',      label: 'Master',      index: 4 },
    { key: 'grandmaster', label: 'Grandmaster', index: 5 },
    { key: 'mythic',      label: 'Mythic',      index: 6 },
];

export const TIER_BY_INDEX = TIERS.reduce((m, t) => { m[t.index] = t; return m; }, {});
export const TIER_BY_KEY = TIERS.reduce((m, t) => { m[t.key] = t; return m; }, {});

// SP cost per tier. Active abilities can be purchased repeatedly — a base cost
// plus an increment for each additional purchase. Passive abilities turn the
// character on in a way that doesn't stack, so they're a single fixed purchase.
// Static abilities are auto-included and free.
export const TIER_COSTS = {
    static:      { free: true },
    basic:       { activeBase: 2,  activeIncrement: 3,  passive: 5 },
    advanced:    { activeBase: 3,  activeIncrement: 5,  passive: 10 },
    expert:      { activeBase: 5,  activeIncrement: 10, passive: 15 },
    master:      { activeBase: 10, activeIncrement: 10, passive: 20 },
    grandmaster: { activeBase: 10, activeIncrement: 20, passive: 30 },
    mythic:      { activeBase: 20, activeIncrement: 20, passive: 40 },
};

// One-line summary of a tier's costs, for the tier header.
export function tierCostLabel(tierKey) {
    const c = TIER_COSTS[tierKey];
    if (!c) return '';
    if (c.free) return 'Free';
    return `Active ${c.activeBase} (+${c.activeIncrement}) · Passive ${c.passive}`;
}

// Cost form shown beneath the tier name in the (rotated) tier label.
export function tierCostStacked(tierKey) {
    const c = TIER_COSTS[tierKey];
    if (!c) return '';
    if (c.free) return 'Free';
    return `Costs: ${c.activeBase}+${c.activeIncrement} | ${c.passive}`;
}

// Cost of one ability given its tier and whether it's passive.
export function abilityCostLabel(tierKey, isPassive) {
    const c = TIER_COSTS[tierKey];
    if (!c) return '';
    if (c.free) return 'Free';
    if (isPassive) return `${c.passive} SP`;
    return `${c.activeBase} SP (+${c.activeIncrement})`;
}
